var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "app-main-inner booking-fail",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.$t("CargoMsg.Cargo_ResultMessage"),
            width: "470px",
            "close-on-click-modal": false,
            "destroy-on-close": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "booking-fail-body",
              staticStyle: {
                height: "160px",
                display: "flex",
                "align-items": "center",
                "justify-content": "center",
                padding: "50px"
              }
            },
            [
              _vm.selectData.bookingErrorCode ===
                _vm.BOOKING_ERROR_CODE_TEMPLATE_NOT_MATCH.code ||
              _vm.selectData.bookingErrorCode ===
                _vm.BOOKING_ERROR_CODE_TEMPLATE_MATCH_TOO_MANY.code ||
              _vm.selectData.bookingErrorCode ===
                _vm.BOOKING_ERROR_CODE_MBL_NOT_FOUND.code ||
              _vm.selectData.bookingErrorCode ===
                _vm.BOOKING_ERROR_CODE_TEMPLATE_CONTENT_VALID_FAIL.code
                ? _c("div", [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.ColumnUtils.bookingErrorCodeLabelFunc(
                            _vm.selectData
                          )
                        )
                      )
                    ])
                  ])
                : _vm.selectData.bookingErrorCode ===
                  _vm.BOOKING_ERROR_CODE_CONTAINS_SENSITIVE_WORD.code
                ? _c("div", [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.ColumnUtils.bookingErrorCodeLabelFunc(
                            _vm.selectData
                          )
                        )
                      )
                    ]),
                    _c("span", { staticStyle: { color: "#f7b45c" } }, [
                      _vm._v(_vm._s(_vm.selectData.bookingErrorMsg))
                    ])
                  ])
                : _vm.selectData.bookingErrorCode ===
                  _vm.BOOKING_ERROR_USERNAME_PASSWORD_NOT_MAINTAINED.code
                ? _c("div", [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.ColumnUtils.bookingErrorCodeLabelFunc(
                            _vm.selectData
                          )
                        )
                      )
                    ]),
                    _c("br"),
                    _c("span", { staticStyle: { color: "#f7b45c" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("CargoMsg.Cargo_UserName_Password_Maintained")
                        )
                      )
                    ])
                  ])
                : _vm.selectData.bookingErrorCode ===
                  _vm.BOOKING_ERROR_SHIP_COMPANY_NOT_MAINTAINED.code
                ? _c("div", [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.ColumnUtils.bookingErrorCodeLabelFunc(
                            _vm.selectData
                          )
                        )
                      )
                    ]),
                    _c("br"),
                    _c("span", { staticStyle: { color: "#f7b45c" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_ShipCompany_Maintained"))
                      )
                    ])
                  ])
                : _vm.selectData.bookingErrorCode ===
                  _vm.BOOKING_ERROR_SHIPPINGCOMPANYCODE_NOT_MAINTAINED.code
                ? _c("div", [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.ColumnUtils.bookingErrorCodeLabelFunc(
                            _vm.selectData
                          )
                        )
                      )
                    ]),
                    _c("br"),
                    _c("span", { staticStyle: { color: "#f7b45c" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "CargoMsg.Cargo_ShippingCompanyCode_MaintainedTip"
                          )
                        )
                      )
                    ])
                  ])
                : _vm.selectData.bookingErrorCode ===
                    _vm.BOOKING_ERROR_YD_RESPONSE_NOT_SUCCESS.code ||
                  _vm.selectData.bookingErrorCode ===
                    _vm.BOOKING_ERROR_GET_BOOKING_RECEIPT_FAIL.code
                ? _c("div", [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.ColumnUtils.bookingErrorCodeLabelFunc(
                            _vm.selectData
                          )
                        )
                      )
                    ]),
                    _c("br"),
                    _c("span", { staticStyle: { color: "#f7b45c" } }, [
                      _vm._v(_vm._s(_vm.selectData.bookingErrorMsg))
                    ])
                  ])
                : _vm.selectData.bookingErrorCode ===
                  _vm.BOOKING_ERROR_BOOKINGCHANNEL_CONFIG_NOT_MAINTAINED.code
                ? _c("div", [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.ColumnUtils.bookingErrorCodeLabelFunc(
                            _vm.selectData
                          )
                        )
                      )
                    ]),
                    _c("br"),
                    _c("span", { staticStyle: { color: "#f7b45c" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "CargoMsg.Cargo_BookingChannelConfig_MaintainedTip"
                          )
                        )
                      )
                    ])
                  ])
                : _c("div", [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.ColumnUtils.bookingErrorCodeLabelFunc(
                            _vm.selectData
                          )
                        )
                      )
                    ])
                  ])
            ]
          ),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _vm.selectData.bookingErrorCode ===
              _vm.BOOKING_ERROR_CODE_TEMPLATE_NOT_MATCH.code ||
            _vm.selectData.bookingErrorCode ===
              _vm.BOOKING_ERROR_CODE_TEMPLATE_MATCH_TOO_MANY.code
              ? _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini" },
                        on: {
                          click: function($event) {
                            _vm.innerVisible = false
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.queryTemplates }
                      },
                      [_vm._v(_vm._s(_vm.$t("Message.SelectTemplate")))]
                    )
                  ],
                  1
                )
              : _vm.selectData.bookingErrorCode ===
                _vm.BOOKING_ERROR_CODE_CONTAINS_SENSITIVE_WORD.code
              ? _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.noBooking }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_NotBooking")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.booking }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ContinueBooking")))]
                    )
                  ],
                  1
                )
              : _vm.selectData.bookingErrorCode ===
                  _vm.BOOKING_ERROR_CODE_MBL_NOT_FOUND.code ||
                _vm.selectData.bookingErrorCode ===
                  _vm.BOOKING_ERROR_CODE_TEMPLATE_CONTENT_VALID_FAIL.code ||
                _vm.selectData.bookingErrorCode ===
                  _vm.BOOKING_ERROR_YD_RESPONSE_NOT_SUCCESS.code
              ? _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.changeInfoHandle }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ChangeInfo")))]
                    )
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function($event) {
                            _vm.innerVisible = false
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Got_It")))]
                    )
                  ],
                  1
                )
          ])
        ]
      ),
      _c("dialog-selector", {
        attrs: {
          visible: _vm.ediSelectorDialog.visible,
          title: _vm.$t("SeaExport.BookingEDI"),
          "row-data": _vm.ediSelectorDialog.rowData
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.ediSelectorDialog, "visible", $event)
          },
          selected: function(p) {
            return _vm.booking(p.uuid)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }